export default __webpack_public_path__ + "static/media/huma-tresfases-03.5a6bfdf4.jpg";